export const guardNumberKeydown = (event: KeyboardEvent) => {
  const invalidChars = ["-", "+", "e", "E"];
  if (invalidChars.includes(event.key)) {
    event.preventDefault();
  }
};

export const guardNumberPaste = (event: ClipboardEvent) => {
  const pasted = event.clipboardData?.getData("text") ?? "";
  if (/[eE+-]/.test(pasted)) {
    event.preventDefault();
  }
};

export const guardNumericInput = (e: KeyboardEvent) => {
  if (
    !/^[0-9]$/.test(e.key) &&
    !["Backspace", "Delete", "Tab", "ArrowLeft", "ArrowRight"].includes(
      e.key,
    ) &&
    !(
      (e.ctrlKey || e.metaKey) &&
      ["a", "c", "v", "x"].includes(e.key.toLowerCase())
    )
  ) {
    e.preventDefault();
  }
};

export const guardNumericPaste = (e: ClipboardEvent) => {
  const paste = e.clipboardData?.getData("text");
  if (paste && !/^\d+$/.test(paste)) {
    e.preventDefault();
  }
};
